import { h, Component } from 'preact';
import { BaseComponent } from "../../common/BaseComponent";
import { version } from '../../version';

export class Refresh extends BaseComponent<any, any>{

    componentDidMount() {
        this.modal.showLoader(this.authService.getVersion())
            .then((v) => {
                if (version != v) {
                    setTimeout(() => { location.reload(true); }, 2000);
                }
                else {
                    location.href = "/";
                }
            });
    }

    render(props?: Readonly<any>, state?: Readonly<any>, context?: any): JSX.Element {
        return <div></div>
    }

}


// WEBPACK FOOTER //
// ./components/refresh/refresh.tsx